import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

const ICONSMAP = [
  'apply',
  'apply-white',
  'arrow',
  'arrow-red',
  'arrow-green',
  'arrow-down',
  'battery',
  'building1-white',
  'calendar4',
  'clear',
  'clear-pink',
  'copy',
  'delete',
  'delete-red',
  'deny-pink',
  'download-new',
  'edit',
  'edit-white',
  'electricity',
  'energy-storage',
  'ess-edit',
  'export-data',
  'export-data-white',
  'filter',
  'hospital-white',
  'info',
  'info-circle',
  'grid-white',
  'load-profile',
  'map2',
  'map-pin',
  'manage-white',
  'no-data',
  'pillar-white',
  'plus',
  'reset',
  'reset-white',
  'reset-pink',
  'run2',
  'search',
  'search-not',
  'search-new',
  'solar-pv',
  'solar-pv-white',
  'spin',
  'spin-purple',
  'tariff',
  'upload-new',
  'warning-red',
  'x',
  'x-white',
];

@Injectable()
export class IconsService {
  constructor(
    private iconRegistry: MatIconRegistry,
    private sanitizer: DomSanitizer,
  ) {}

  load(): Promise<void> {
    return new Promise<void>(resolve => {
      ICONSMAP.forEach(ico => {
        this.iconRegistry.addSvgIcon(
          ico,
          this.sanitizer.bypassSecurityTrustResourceUrl(
            `/assets/svg-icons/${ico}.svg`,
          ),
        );
      });
      resolve();
    });
  }
}
